/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'backgrounds/qr-frame': {
    width: 16,
    height: 16,
    viewBox: '0 0 280 280',
    data: '<g data-name="Layer 2"><g data-name="Layer 1" _fill="#cd5a49"><path pid="0" d="M62 .06H7.94V0H.06v.06H0v7.88h.06V62h7.88V7.94H62V.06zM.06 218v54.06H0v7.88h.06v.06h7.88v-.06H62v-7.88H7.94V218H.06zM218 279.94h54.06v.06h7.88v-.06h.06v-7.88h-.06V218h-7.88v54.06H218v7.88zM279.94 62V7.94h.06V.06h-.06V0h-7.88v.06H218v7.88h54.06V62h7.88z"/></g></g>'
  }
})
